var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-text',{attrs:{"geometry":"primitive:plane","material":"color: #ece600;","font":"exo2bold","value":"AFV","align":"center","color":"#fff"}})}
var staticRenderFns = []

export { render, staticRenderFns }